var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { GetExportPaperJobApi } from '../../apis/get-export-paper-job-api';
let ExportPaperRepositoryImpl = class ExportPaperRepositoryImpl {
    constructor(_getExportPaperJobApi) {
        this._getExportPaperJobApi = _getExportPaperJobApi;
    }
    async exportPapers(task, options) {
        const params = this._getParams(task, options);
        const result = await this._getExportPaperJobApi.getExportPaperJob(params);
        return result.job_id;
    }
    _getParams(task, options) {
        return {
            select_mode: task.selectMode,
            start: task.start,
            end: task.end,
            sort: task.sort,
            doc_ids: task.docIds,
            refiner: task.filters,
            folderId: task.folderId,
            language: options.language,
            notify_by_email: options.notifyByEmail,
            ...this._getExportDateAndTime(),
        };
    }
    _getExportDateAndTime() {
        const date = new Date();
        return {
            export_date: date.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/\//g, '-'),
            export_time: date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }),
        };
    }
};
ExportPaperRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(GetExportPaperJobApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof GetExportPaperJobApi !== "undefined" && GetExportPaperJobApi) === "function" ? _a : Object])
], ExportPaperRepositoryImpl);
export { ExportPaperRepositoryImpl };
